import type { PropsWithChildren } from 'react'
import { Link, NavLink, useNavigate } from 'react-router'

import { useAuth } from '../../auth/AuthContext'

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `px-3 py-2 rounded ${isActive ? 'bg-gray-800 text-white' : 'text-gray-300 hover:text-white hover:bg-gray-800'}`

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  const { me, logout } = useAuth()
  const navigate = useNavigate()

  const onLogout = async () => {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="min-h-full">
      <header className="bg-gray-900 text-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3">
          <Link to="/" className="text-lg font-semibold tracking-tight">
            snacks
          </Link>
          <nav className="flex items-center gap-1 text-sm">
            <NavLink to="/" end className={navLinkClass}>
              My entries
            </NavLink>
            <NavLink to="/users" className={navLinkClass}>
              Users
            </NavLink>
          </nav>
          <div className="flex items-center gap-3 text-sm">
            {me ? (
              <>
                <span className="text-gray-300">{me.email}</span>
                <button
                  type="button"
                  onClick={onLogout}
                  className="rounded bg-gray-800 px-3 py-2 hover:bg-gray-700"
                >
                  Log out
                </button>
              </>
            ) : (
              <NavLink to="/login" className={navLinkClass}>
                Log in
              </NavLink>
            )}
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-8">{children}</main>
    </div>
  )
}

export default Layout
